import * as React from 'react';
import { useSelector } from 'react-redux';

import { EarlyAccessPaywallProvider as Provider } from '../../../packages/EarlyAccessPaywall';
import { ESource } from '../../../packages/EarlyAccessPaywall/shared/types/context';
import { getUser } from 'shared/selectors/user';
import { getEarlyAccessPaywallMicrofrontend } from 'shared/services/getEarlyAccessPaywallMicrofrontend';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const EarlyAccessPaywallProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const context = useApplicationContext();
  const fetchManifest = React.useCallback(async () => getEarlyAccessPaywallMicrofrontend(context), [context]);
  const user = useSelector(getUser);
  const isAuthenticated = !!user?.isAuthenticated;

  const params = {
    isAuthenticated,
    source: ESource.Listing,
  };

  return (
    <Provider fetchManifest={fetchManifest} params={params}>
      {children}
    </Provider>
  );
};
